import Vue from 'vue'
import Vuex from 'vuex'
import PlaceModule from './modules/place'
import TypesModule from './modules/types_module'
import ProductModule from './modules/product_module'
import WorkerModule from './modules/worker_module'
import WorkerRecordModule from './modules/worker_record_module'
import SoilSerieModule from './modules/soils/soil_serie'
import SoilHorizonModule from './modules/soils/soil_horizon'
import SoilStructureModule from './modules/soils/soil_structure'
import PropagationMethodModule from './modules/propagation/propagation_method'
import PropagationProductModule from './modules/propagation/propagation_product'
// Lifetime
import LifetimePeriodModule from './modules/lifetime/lifetime_period'
import LifetimeLifeStateModule from './modules/lifetime/lifetime_lifestate'
import LifetimeRecordModule from './modules/lifetime/lifetime_record'
import LifetimeModule from './modules/lifetime/lifetime'

import ProductivityModule from './modules/productivity/productivity'
import SeasonalityRecordModule from './modules/seasonality/seasonality_record'
import SeasonalityDataModule from './modules/seasonality/seasonality_data'
import VarietyModule from './modules/variety/variety'
import PartsModule from './modules/parts/parts'
import PartTypeModule from './modules/parts/parttype'
import UnitGroupModule from './modules/unit/unit_group'
import PermissionModule from './modules/permission'
import ProductViewModule from './modules/product/product_view'
// farmerSpace
import ContentTypeModule from './modules/farmerspace/content_type'
import ContentModule from './modules/farmerspace/content'
import FarmerSpaceTopicModule from './modules/farmerspace/topic'
import FarmerSpaceExamModule from './modules/farmerspace/exam'
import FarmerSpaceChoiceModule from './modules/farmerspace/choice'
// Cropperz
import SupplierModule from './modules/cropperz/supplier'
// workflow
import WorkflowRecordModule from './modules/workflow/workflow_record'
import WorkflowModule from './modules/workflow/workflow'
// Equipment
import EquipmentModule from './modules/equipment/equipment'
import SoilInFarmModule from './modules/soils/soil_in_farm'
// Properties
import PropertiesTypeModule from './modules/properties/properties_type'
import PropertiesInFarmModule from './modules/properties/properties_in_farm'

import SourcesModule from './modules/wesources/sources'
import SourcesReferModule from './modules/wesources/sources_refer'
import SourcesIndexModule from './modules/wesources/sources_index'
import UnitMeasureModule from './modules/unit_measure'
import PhasesModule from './modules/phases'
import RawDataModule from './modules/rawdata/raw_data'
import RawDataTypeModule from './modules/rawdata/raw_data_type'

// Cropperz
import CropperzUsersModule from './modules/cropperz/cropperz_users'

import FestivalsModule from './modules/festivals/festivals'
import FestivalPlacesModule from './modules/festivals/festivals_places'
import FestivalProductsModule from './modules/festivals/festivals_products'
import PackageProductModule from './modules/package_product/package_product'
import PackageProductTypeModule from './modules/package_product/package_product_type'
import DocumentModule from './modules/document/document'
import DocumentTypeModule from './modules/document/document_type'
import CookingMenuTypeModule from './modules/cooking/cooking_menu_type'
import CookingMethodModule from './modules/cooking/cooking_method'
import CookingMenuModule from './modules/cooking/cooking_menu'
import IngredientModule from './modules/cooking/ingredient'
import RecipesModule from './modules/cooking/recipes'
import VehicleTypeModule from './modules/logistics/vehicle_type'
import VehicleConditionTypeModule from './modules/logistics/vehicle_condition_type'
import MotorFuelTypeModule from './modules/logistics/motor_fuel_type'
import MotorFuelModule from './modules/logistics/motor_fuel'
import DiseaseInFarmModule from './modules/diseases/disease_in_farm'
import VehicleModule from './modules/logistics/vehicle'
import VehicleConditionModule from './modules/logistics/vehicle_condition'
import NotificationModule from './modules/notification'
import SoilPlacesModule from './modules/soils/soil_places'
import IndicationModule from './modules/geographical/indication'
import GlycemicIndexModule from './modules/glycemic/glycemic_index'
import GlycemicIndexInfarmModule from './modules/glycemic/glycemic_index_infarm'
import FarmerSpaceKnowledgeModule from './modules/farmerspace/knowledge'
import SiteModule from './modules/site'
import PagesModule from './modules/page'
import BannerPositionsModule from './modules/banners/banner_position'
import BannerModule from './modules/banners/banner'
import SoilColorModule from './modules/soils/soil_color'
import SoilLayerNameModule from './modules/soils/soil_layer_name'
import SoilTextureModule from './modules/soils/soil_texture'
import SoilSeriesDetailModule from './modules/soils/soil_series_detail'
import ProductInPlaceModule from './modules/product/product_in_place'
import GradeGroupModule from './modules/grade/grade-group'
import GradeModule from './modules/grade/grade'
import TypeGroupModule from './modules/types/type_group'
import PartsGroupModule from './modules/parts/parts_group'
import GradeListModule from './modules/grade/grade-list'
import GradeDetailModule from './modules/grade/grade-detail'
import FarmerSpaceInternModule from './modules/farmerspace/internship'
import ProductContentModule from './modules/product/product_content'

// Make vue aware of Vuex
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const modules = {
  PartsGroup: PartsGroupModule,
  TypeGroup: TypeGroupModule,
  Grade: GradeModule,
  Place: PlaceModule,
  Permission: PermissionModule,
  Types: TypesModule,
  Product: ProductModule,
  Worker: WorkerModule,
  WorkerRecord: WorkerRecordModule,
  SoilSerie: SoilSerieModule,
  SoilHorizon: SoilHorizonModule,
  SoilStructure: SoilStructureModule,
  SoilPlaces: SoilPlacesModule,
  PropagationMethod: PropagationMethodModule,
  PropagationProduct: PropagationProductModule,
  LifetimePeriod: LifetimePeriodModule,
  LifetimeLifeState: LifetimeLifeStateModule,
  Productivity: ProductivityModule,
  SeasonalityRecord: SeasonalityRecordModule,
  SeasonalityData: SeasonalityDataModule,
  Variety: VarietyModule,
  Parts: PartsModule,
  PartType: PartTypeModule,
  UnitGroup: UnitGroupModule,
  ProductView: ProductViewModule,
  ContentType: ContentTypeModule,
  Content: ContentModule,
  Supplier: SupplierModule,
  WorkflowRecord: WorkflowRecordModule,
  Workflow: WorkflowModule,
  Equipment: EquipmentModule,
  SoilInFarm: SoilInFarmModule,
  FarmerSpaceTopic: FarmerSpaceTopicModule,
  FarmerSpaceExam: FarmerSpaceExamModule,
  FarmerSpaceChoice: FarmerSpaceChoiceModule,
  PropertiesType: PropertiesTypeModule,
  PropertiesInFarm: PropertiesInFarmModule,
  Sources: SourcesModule,
  SourcesRefer: SourcesReferModule,
  SourcesIndex: SourcesIndexModule,
  DiseaseInFarm: DiseaseInFarmModule,
  UnitMeasure: UnitMeasureModule,
  Phases: PhasesModule,
  RawData: RawDataModule,
  RawDataType: RawDataTypeModule,
  LifetimeRecord: LifetimeRecordModule,
  Lifetime: LifetimeModule,
  CropperzUsers: CropperzUsersModule,
  Festivals: FestivalsModule,
  FestivalPlaces: FestivalPlacesModule,
  FestivalProducts: FestivalProductsModule,
  PackageProduct: PackageProductModule,
  PackageProductType: PackageProductTypeModule,
  Document: DocumentModule,
  DocumentType: DocumentTypeModule,
  CookingMenuType: CookingMenuTypeModule,
  CookingMethod: CookingMethodModule,
  CookingMenu: CookingMenuModule,
  Ingredient: IngredientModule,
  Recipes: RecipesModule,
  Vehicle: VehicleModule,
  VehicleType: VehicleTypeModule,
  VehicleCondition: VehicleConditionModule,
  VehicleConditionType: VehicleConditionTypeModule,
  MotorFuelType: MotorFuelTypeModule,
  MotorFuel: MotorFuelModule,
  Notification: NotificationModule,
  Indication: IndicationModule,
  GlycemicIndex: GlycemicIndexModule,
  GlycemicIndexInfarm: GlycemicIndexInfarmModule,
  FarmerSpaceKnowledge: FarmerSpaceKnowledgeModule,
  Site: SiteModule,
  Pages: PagesModule,
  BannerPositions: BannerPositionsModule,
  Banner: BannerModule,
  SoilColor: SoilColorModule,
  SoilLayerName: SoilLayerNameModule,
  SoilTexture: SoilTextureModule,
  SoilSeriesDetail: SoilSeriesDetailModule,
  ProductInPlace: ProductInPlaceModule,
  GradeGroup: GradeGroupModule,
  GradeList: GradeListModule,
  GradeDetail: GradeDetailModule,
  FarmerSpaceIntern: FarmerSpaceInternModule,
  ProductContent: ProductContentModule
}
// Combine the initial state and the mutations to create a Vuex store.
// This store can be linked to our app.
export default new Vuex.Store({
  modules,
  strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js